import { renderCostComparisonChart } from "../charts/cost_comparison_chart"

export const CostComparisonChart = {
  mounted() {
    this.chart = renderCostComparisonChart(
      this.el,
      JSON.parse(this.el.dataset.chartData),
    )
  },

  updated() {
    if (this.chart) {
      this.chart.destroy()
    }
    this.chart = renderCostComparisonChart(
      this.el,
      JSON.parse(this.el.dataset.chartData),
    )
  },

  destroyed() {
    if (this.chart) {
      this.chart.destroy()
    }
  },
}
